import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=7d4eef2a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d4eef2a')) {
      api.createRecord('7d4eef2a', component.options)
    } else {
      api.reload('7d4eef2a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=7d4eef2a&", function () {
      api.rerender('7d4eef2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24EhCBt4M16o6/JS/imageCarousel.vue"
export default component.exports